/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Icon, Text } from 'components';
import TourEditContext from '../TourEditContext';
import { TourAutoSaveStatus } from '../types';
import MobileFriendlyTooltip from '../MobileFriendlyTooltip';

const TourAutoSaveIndicator: React.FC = () => {
  const { autoSaveStatus } = useContext(TourEditContext);

  const AutoSaveComponentMap: Record<
    TourAutoSaveStatus,
    {
      text?: JSX.Element;
      icon: JSX.Element;
      tooltip: string;
    }
  > = {
    [TourAutoSaveStatus.UNSAVED]: {
      text: <Text type={'secondary'}>Saving</Text>,
      icon: <Icon type="antdCheckCircleFilled" width={14} />,
      tooltip:
        'Unsaved changes. We will automatically save them in a moment....',
    },
    [TourAutoSaveStatus.SAVING]: {
      text: <Text type={'secondary'}>Saving</Text>,
      icon: <Icon type="antdLoadingOutlined" color="success" width={14} />,
      tooltip: 'Saving...',
    },
    [TourAutoSaveStatus.SAVED]: {
      text: <Text type={'secondary'}>Saved</Text>,
      icon: <Icon type="antdCheckCircleFilled" color="success" width={14} />,
      tooltip: 'Saved!',
    },
    [TourAutoSaveStatus.ERROR]: {
      icon: <Icon type="antdCloseCircleFilled" color="danger" width={14} />,
      tooltip: 'Error saving. We will try again in a moment...',
    },
    [TourAutoSaveStatus.ERROR_RETRIED]: {
      icon: <Icon type="antdCloseCircleFilled" color="danger" width={14} />,
      tooltip: 'Error retrying the auto-save. Please refresh the page.',
    },
  };

  return (
    <StyledAutoSaveContainer>
      <MobileFriendlyTooltip
        title={AutoSaveComponentMap[autoSaveStatus].tooltip}
      >
        {AutoSaveComponentMap[autoSaveStatus].text}{' '}
        {AutoSaveComponentMap[autoSaveStatus].icon}{' '}
      </MobileFriendlyTooltip>
    </StyledAutoSaveContainer>
  );
};

export default TourAutoSaveIndicator;

const StyledAutoSaveContainer = styled.div`
  margin-top: 1px;
  margin-right: 20px;
`;
